import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminExchanges;

export const adminExchangesSelector = createSelector(getState, (state) => state.exchanges);
export const adminExchangesMetaSelector = createSelector(getState, (state) => state.exchangesMeta);
export const isLoadingExchangesSelector = createSelector(
  getState,
  (state) => state.isLoadingExchanges,
);

export const selectedExchangeSelector = createSelector(getState, (state) => state.selectedExchange);
export const isLoadingExchangeSelector = createSelector(
  getState,
  (state) => state.isLoadingExchange,
);

export const adminExchangeErrorsSelector = createSelector(getState, (state) => state.errors);
